<template>
    <header
        :class="['d-flex flex-column', { 'align-items-center': isCompact }]"
        style="gap: var(--space-3)"
    >
        <!-- Logo -->
        <div class="d-flex justify-content-between">
            <router-link to="/" class="logo-link">
                <img
                    :src="currentLogo"
                    :alt="logoAltText"
                    :class="logoClass"
                    @error="handleLogoError"
                    @click="$emit('link-clicked')"
                />
            </router-link>

            <button
                v-if="this.$isMobile"
                type="button"
                class="btn btn-white"
                @click="toggleSidebar()"
            >
                <i class="fi fi-x"></i>
            </button>
        </div>

        <!-- Separator -->
        <div class="separator-line w-100" role="separator"></div>

        <!-- Company Info & Controls -->
        <div
            :class="[
                {
                    'd-flex justify-content-between align-items-center':
                        !this.$isMobile,
                },
            ]"
        >
            <!-- Alpha Access: Show logo + name -->
            <div
                v-if="$userStore?.hasAlphaAccess && !isCompact"
                class="client-info d-flex flex-row align-items-center"
            >
                <!-- Huron Dental Group -->
                <div
                    v-if="companyName === 'Huron Dental Group'"
                    class="client-logo"
                >
                    <svg
                        id="Layer_2"
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        viewBox="0 0 20.56 24"
                    >
                        <g id="Layer_1-2">
                            <g>
                                <g>
                                    <g>
                                        <path
                                            d="M12.45.57c.04-.04.08-.06.06-.09-.04.02-.12.07-.12.07.02.02.04.04.06.02Z"
                                            fill="#025390"
                                        />
                                        <path
                                            d="M19.57,3.26h.01c-.21-.47-.4-.98-.78-1.33.05.17.24.3.17.5-.005,0-.005-.004-.009-.005.046-.191-.122-.32-.171-.485-.02-.02-.03-.04-.05-.06-.04-.15-.09-.31-.25-.36-.008.009-.002.014-.008.022-1.422-1.742-4.025-1.821-5.972-1.032.02.04-.02.06-.06.09-.01.02-.03.01-.06-.02-.04-.01-.09.04-.12.04-.23.2-.55.38-.85.38h-.06c-.03.07-.1.11-.18.12h-.05c-.037.103-.176.13-.194.24h-.006v.002h.006c-.001.006-.006.01-.006.018.004-.001.006-.002.01-.003v.083s-.008.005-.01.008v-.106l-.12.028c-.014.019-.011.04-.002.06-.01-.02-.009-.042.002-.062l.121-.028-.01-.01c0-.12.17-.14.2-.26-.253.097-.468.269-.71.398-.004,0-.007.002-.01.002h-.06c-.024-.004-.046-.017-.07-.023-.147-.139-.35-.224-.543-.291-.017-.018-.042-.027-.058-.046h-.017c-.218-.173-.499-.281-.773-.31-.02-.01-.04-.04-.06-.04-.4-.19-.85-.3-1.28-.36h-.11l.01-.01s-.007,0-.01,0c-.818-.205-1.711-.271-2.534-.072-.018-.001-.038.003-.056.002h-.06c-.018.011-.04.014-.059.023-.216.003-.441.032-.622.134-.016-.001-.033.005-.049.003-.03-.01-.08.02-.11.02-.022.017-.055.023-.078.039-.325.074-.67.185-.945.371-.022.007-.045.013-.067.02l-.06.06s-.007.007-.01.01c-.285.069-.531.283-.777.48h-.003c-.6.46-1.02,1.08-1.32,1.75.1.08-.03.17-.07.36l1.479-.089-.009.009-1.49.09c.04-.2.17-.28.07-.36C.36,3.93.09,4.62.05,5.37c-.09.2,1.12.14,1.14.09.01-.09,0-.24.03-.31.03-.05.13-.15.16-.02.2-.54.41-1.109.71-1.609h.01c.22-.371.66-.601.92-.941-.036-.003-.061-.018-.079-.04.017.017.037.03.069.03.01-.02.05-.03.05-.05.13,0,.24-.08.32-.18.45-.22.9-.44,1.38-.6.08-.03.15-.1.25-.06h.06c.02-.08.12-.05.18-.05h.06s0,0,0,0l.359-.019c.01-.02,0-.06,0-.06l-.009-.009s.006,0,.009,0c.005-.012,0-.021,0-.032.007.016.026.021.021.052-.01.02,0,.04,0,.06.057-.009.113.008.17.009,0,0,0,0,0,0,.08,0,.2.03.24-.06-.048-.019-.088-.065-.145-.068.002,0,.002-.002.005-.002.06,0,.15.07.15.07h.29c.1.09.24.06.36.06v-.11s.007,0,.01,0v.11h.12s.3-.02.3-.02c.02-.08.01-.15,0-.22l-.01.01c-.596.019-.517-.282-.773-.138,0,0-.002,0-.002,0,.002,0,.004,0,.006-.001.28-.17.18.15.79.12,0,.07.01.15,0,.22.34-.02.68.16,1.03.19-.14-.19-.44-.14-.67-.26-.05-.02-.16.08-.21.03-.05-.05-.04-.12-.04-.18h.01s.007-.002.01-.005c-.009.059-.008.136.04.174.05.04.16-.05.21-.03.23.12.54.06.67.26h.104s-.009.009-.014.01c.07.1.19.12.31.12h.01c-.03-.07-.02-.21-.11-.27-.013-.007-.025-.002-.038.003.02-.016.04-.025.058-.013.1.06.09.2.11.27.04,0,.07.01.11.01h.048s-.004.008-.005.013c-.004-.001-.009-.002-.013-.003h-.06l1.389.591c.006.011.016.017.021.029h.03s.001-.003.002-.004c.011.049.04.115.098.115.05,0,.13-.02.19-.05l.86-.51h-.089c.085-.241-.513-.039-.641.01-.232-.127-.588-.176-.823-.049.23-.144.603-.106.853.019.13-.05.75-.26.64,0,.03-.01.06,0,.09,0h.033c0,.012-.005.015-.003.03.18-.1.4-.11.55-.24-.283.085-.455.044-.521.103.039-.104.213-.036.541-.133.02,0,.05.01.06,0,.09-.17.3-.19.48-.22h.06c.07-.12.23-.12.36-.13h.12c.02-.05.07-.05.12-.05h.06c-.01-.03.01-.06.03-.06.05-.02.09,0,.09.05.086.038.162-.039.23-.046v.016c.748,0,1.477-.037,2.206.115.014.007.03.008.044.015.44.23.89.44,1.29.73.007-.002.01-.002.017-.004.266.2.456.476.693.704.17.16.29.38.44.61h1.278s.001.006.002.01h-1.29c-.15-.23-.26-.45-.44-.62.54.83,1.05,1.7,1.22,2.66.2-.12.4-.08.67-.05.27.03.41-.29.46-.49-.15-.62-.36-1.23-.61-1.81ZM2.58,1.22c.031-.037.069-.07.105-.105-.032.032-.066.062-.095.095.029.076.093.096.143.08-.005.003-.008.009-.013.01-.049.01-.116-.011-.147-.077.002-.001.005-.002.007-.003ZM2.84,2.36c-.34-.07-.98.49-1.4-.05,0,0,0,0,0,0,.43.519,1.052-.029,1.39.041.021.003.034.02.044.043-.009-.017-.018-.031-.034-.033ZM6.639,1.51s0,0,0,0c-.037,0-.082-.006-.124-.004.042-.004.086.002.124.003ZM6.411,1.277l.009.013c-.1.05-.27-.05-.36,0-.208.119-.454-.015-.663.117-.009-.006-.018-.008-.027-.017.2-.14.45,0,.67-.12h-.01c-.24-.26-.6-.01-.92-.05l-.81-.09c-.22-.03-.35.04-.59.03l-.82-.039s.006-.01.01-.01l.83.04c.24.01.36-.05.59-.03l.81.09c.32.03.67-.21.92.05.097-.039.26.052.351.002v.002s-.006.003-.011.006c.007.004.014.003.021.007ZM9.25,1.11c.019.038,0,.089-.053.087-.002-.003-.005-.003-.006-.006.038-.01.056-.048.039-.081-.01-.025-.032-.032-.058-.033.031,0,.06.004.078.033ZM9.618,2.232s-.006-.001-.008-.002c-.19-.04-.32-.25-.53-.25h.01c0-.11.01-.22-.03-.36-.067.022-.108.066-.142.114.035-.059.085-.109.162-.134.04.14.03.25.03.36.21,0,.33.209.53.25-.006.009-.016.012-.021.022ZM9.85,1.44c.04,0,.07.07.07.07,0-.039-.031-.07-.07-.07ZM11.9,1.5c.04,0,.07.07.07.07,0-.039-.031-.07-.07-.07ZM12.265,1.575s-.002.005-.005.005c-.04,0-.07-.03-.07-.07s.03-.07.07-.07c.002,0,.004.004.006.004-.036.003-.066.029-.066.066,0,.036.03.061.065.065ZM18.66,2.33s0,0,0,0c.042-.022.062-.102.081-.12.002-.002.005-.002.007-.003-.019.027-.039.123-.087.123Z"
                                            fill="#025390"
                                        />
                                        <path
                                            d="M11.42.96c.31,0,.62-.17.85-.38-.29.07-.64.16-.85.38Z"
                                            fill="#025390"
                                        />
                                        <path
                                            d="M5.01,1.69c-.1-.04-.17.03-.25.06.08,0,.21.03.25-.06Z"
                                            fill="#025390"
                                        />
                                        <path
                                            d="M12.51,1.64c-.17.02-.39.05-.48.22.14-.12.37-.07.48-.22Z"
                                            fill="#025390"
                                        />
                                        <path
                                            d="M12.93,1.51c-.13.01-.28.01-.36.13.13-.01.27-.03.36-.13Z"
                                            fill="#025390"
                                        />
                                        <path
                                            d="M5.25,1.64c-.06-.01-.16-.04-.18.04.06,0,.16.03.18-.04Z"
                                            fill="#025390"
                                        />
                                        <path
                                            d="M13.17,1.45c-.05,0-.1,0-.12.05.05,0,.11.01.12-.05Z"
                                            fill="#025390"
                                        />
                                        <path
                                            d="M13.27,1.38c-.03.01-.03.03-.03.06.04.02.12,0,.12,0v-.01c.01-.05-.04-.07-.09-.05Z"
                                            fill="#025390"
                                        />
                                        <path
                                            d="M11.36.97c-.08,0-.15.05-.18.12.08-.01.15-.04.18-.12Z"
                                            fill="#025390"
                                        />
                                    </g>
                                    <g>
                                        <path
                                            d="M1.2,8.89c-.04.037-.06.078-.067.124.007-.048.026-.092.067-.134v-.12c-.2-.42-.13-.93-.1-1.39,0-.03-.01-.12-.01-.12h-.01c-.11-.01-.23-.09-.32-.08-.033.004-.053.021-.068.042.015-.026.039-.046.078-.052.08-.01.2.07.32.08.02-.05-.02-.14.01-.18-.02-.07-.06-.2.03-.24.04-.55.06-1.16.25-1.69h.01c-.04-.13-.14-.03-.16.02-.03.06-.03.22-.03.31-.02.05-1.23.11-1.14-.09-.01.22-.06.43-.06.67l.14,1.51c.128-.099.343-.043.483-.089-.002.002-.001.007-.003.009-.14.05-.36-.01-.49.09L-.01,6.04v1.62c.014-.051.027-.06.04-.048-.01.002-.02.009-.03.048,0,.33.03.67.12.98.004.012.006,0,.009,0-.004.023-.01.025-.019,0v.12c.23.2.06.56.23.84.24-.15.599-.24.859-.06,0,.004.001.007.001.01-.27-.17-.62-.09-.86.06-.17-.28,0-.64-.23-.84.07.77.22,1.53.33,2.33.38.03.73.02,1.12,0-.2-.75-.24-1.49-.36-2.22v.01Z"
                                            fill="#053c6a"
                                        />
                                        <path
                                            d="M20.55,9.36c-.14.11-.09.3-.12.5.03-.21-.02-.4.12-.5l-.04-.34c-.03-.31.06-.62.04-.93,0-.13,0-.3-.04-.42h.01c-.007-.002-.013-.005-.02-.008.057-.297-.02-.595-.02-.902,0,0,0,0-.001-.001-.002-.131-.049-.332-.069-.469-.039.068-.062.165-.058.255-.007-.093.018-.194.058-.265h-.01c-.03-.14-.03-.32-.07-.48l-.17-.73c-.05.2-.21.53-.46.49s-.46-.07-.67.05l.3,1.64c0-.02.01-.05.02-.08.01-.029.029-.026.052-.008-.012-.002-.025-.01-.032.008-.02.04-.02.08-.02.08l.042.548c.013-.014.016-.038.038-.038.002,0,.004.004.006.004-.023.002-.032.024-.043.043v-.009c-.011.012-.033.014-.033.032,0,.021.023.025.037.037v-.011c.01.016.017.036.038.038-.003,0-.002.005-.005.005-.019,0-.02-.022-.033-.033l.013.163c.015.232.03.482.033.732-.004-.247-.019-.495-.033-.723v1.45s0-.003,0-.005c0,.099.019.216,0,.305.03.03.09.16.09.16-.04.02-.09-.16-.09-.16-.1.41-.08.85-.13,1.31h1.08c.11-.6.25-1.18.19-1.74ZM20.082,7.498c-.146-.046-.298-.063-.472.002,0,0-.001-.003-.001-.004.174-.064.327-.047.473.002ZM19.487,7.807c-.006-.01-.013-.017-.023-.023.01.01.017.013.023.023ZM20.093,9.767c-.012-.041-.055-.093-.066-.157.012.062.055.115.066.157ZM20.181,9.565c.065.058.084.15.136.218-.052-.068-.071-.16-.136-.218Z"
                                            fill="#053c6a"
                                        />
                                        <path
                                            d="M1.2,8.76l-.1-1.39c-.02.46-.09.96.1,1.39Z"
                                            fill="#053c6a"
                                        />
                                        <path
                                            d="M1.11,7.07c.05-.08.03-.15.03-.24-.09.04-.05.16-.03.24Z"
                                            fill="#053c6a"
                                        />
                                    </g>
                                </g>
                                <g>
                                    <path
                                        d="M15.59,21.15c-.59.62-1.28,1.11-1.98,1.57,0-.09-.09-.17-.2-.17h-1.57l-.96.09c-.22.02-.45-.16-.7-.08-.03-.14-.02-.22-.02-.31.02-.19.07-.4.14-.56.19-.07.37-.17.57-.19-.05.26.04.72.33.79.51.12,1.02-.15,1.44-.4.48-.28,1-.49,1.39-.85.03.23.32.1.5.1.37-.01.72.07,1.07.02l-.01-.01Z"
                                        fill="#989594"
                                    />
                                    <path
                                        d="M13.61,22.72c-.58.37-2.55,1.78-3.31,1.1-.43-.39-.19-1.32-.15-1.57,0,.09,0,.16.02.31.25-.07.48.11.7.08l.96-.1h1.57c.11.02.21.09.2.18h.01Z"
                                        fill="#9d9998"
                                    />
                                    <path
                                        d="M8.88,21.34c-.13.63-.64,1.66-1.46,1.67-.67,0-1.21-.36-1.68-.76.13.02.18-.03.17-.15-.02-.26-.43-.11-.48-.37-.02-.1.08-.23.22-.24.75-.07,1.33,1,1.1.22.34.18.8.06,1.05-.18l1.08-.18v-.01ZM7.07,21.88s-.03-.07-.07-.07-.07.03-.07.07.03.07.07.07.07-.03.07-.07Z"
                                        fill="#9a9696"
                                    />
                                    <path
                                        d="M12.33,16.08s-.07.05-.06.08c0,.03.03.04.06.04,0,.19-.17.37-.19.54-.09.03-.24.13-.29,0,.01-.03,0-.08,0-.12.05-.02.06-.07.06-.12v-.06c.07-.03.06-.12.06-.18v-.12c.07-.03.06-.12.06-.18v-1.02c0-.26-.2-.45-.36-.52-.41-.18-1.04,0-1.33.36-.41.53-.69,1.19-.79,1.86-.19.05-.15-.25-.35-.24-.08,0-.16.07-.23.1-.06.02-.11-.04-.14-.1.19-.56.4-1.08.81-1.57.56-.67,1.69-1.05,2.42-.46.48.39.35,1.21.28,1.72l-.01-.01Z"
                                        fill="#828182"
                                    />
                                    <path
                                        d="M16.92,19.63c-.39.55-.86,1.03-1.33,1.52-.35.05-.7-.03-1.07-.02-.18,0-.47.13-.5-.1l1.64-1.52c.27.14.79-.09,1.26.12Z"
                                        fill="#928f8f"
                                    />
                                    <path
                                        d="M.72,11.78c.32.15.69.02,1.03.06l.53,2.22c-.22-.08-.49-.28-.73-.12-.1.06-.1.34-.27.25-.05-.18-.74-2.38-.64-2.41h.09-.01Z"
                                        fill="#7a797a"
                                    />
                                    <path
                                        d="M2.28,14.07c.18.76.51,1.51.79,2.25-.18.04-.26-.11-.3-.35l-.84.1c-.25-.61-.47-1.23-.66-1.87.18.09.18-.19.27-.25.24-.16.51.04.73.12h.01Z"
                                        fill="#817f80"
                                    />
                                    <path
                                        d="M4.94,19.95c.28.46.69.89,1.08,1.3.18.18.52.35.74.46.23.78-.35-.29-1.1-.22-.14.01-.24.14-.22.24.04.26.46.11.48.37.01.13-.04.17-.17.15-.66-.57-1.22-1.25-1.69-2,.33.08-.16-.47.06-.5.32-.04.6.12.77.4.12-.06.07-.14.07-.21l-.02.01Z"
                                        fill="#959292"
                                    />
                                    <path
                                        d="M3.91,18.19c.27.61.68,1.19,1.03,1.76,0,.06.06.15-.07.21-.17-.28-.45-.44-.77-.4-.22.02.27.58-.06.5-.09-.14-.21-.26-.24-.42-.01-.06-.07-.1-.12-.12-.36-.53-.59-1.14-.9-1.7.25.02.13-.33.39-.36.21-.03.53.57.74.55v-.02Z"
                                        fill="#8d8c8c"
                                    />
                                    <path
                                        d="M19.28,11.78c.3.15.65.02.97.06-.12.65-.2,1.32-.42,1.93-.37-.08-.77.02-1.13-.12l.37-1.62c.02-.08-.03-.17.05-.21.05-.02.1-.05.17-.04h-.01Z"
                                        fill="#7a797a"
                                    />
                                    <path
                                        d="M18.01,18c-.3.58-.71,1.1-1.09,1.63-.47-.2-.98.02-1.26-.12.23-.51.75-.88,1.02-1.37.03.08.19.05.24-.02.4-.53.77-.06,1.09-.12Z"
                                        fill="#8c8b8c"
                                    />
                                    <path
                                        d="M3.07,16.32c.23.62.57,1.25.84,1.87-.21.02-.54-.58-.74-.55-.25.04-.14.38-.39.36-.34-.63-.59-1.28-.86-1.94l.84-.1c.04.25.12.39.3.35l.01.01Z"
                                        fill="#878687"
                                    />
                                    <path
                                        d="M18.74,16.61c-.2.49-.48.92-.73,1.39-.32.06-.69-.4-1.09.12-.05.07-.21.1-.24.02l.91-1.64c0,.07-.04.16.07.19.18-.24.57-.39.83-.21.09.06.12.21.25.13Z"
                                        fill="#888687"
                                    />
                                    <path
                                        d="M19.21,15.46c-.14.39-.32.76-.48,1.15-.13.08-.16-.06-.25-.13-.26-.18-.65-.04-.83.21-.11-.03-.06-.12-.07-.19.24-.43.45-.93.61-1.39-.07.21.89-.5,1.08.18.01.04-.2,0-.22.04-.01.03-.02.11.02.13s.1,0,.14,0Z"
                                        fill="#828182"
                                    />
                                    <path
                                        d="M9.18,19.7c-.05.55-.19,1.09-.3,1.63l-1.08.18c.27-.61.32-1.26.49-1.89.3.03.6-.02.9.07l-.01.01Z"
                                        fill="#949190"
                                    />
                                    <path
                                        d="M19.82,13.78l-.61,1.68s-.09.02-.14,0-.03-.1-.02-.13c.02-.04.23,0,.22-.04-.19-.68-1.14.03-1.08-.18l.49-1.45c.36.14.76.04,1.13.12h.01Z"
                                        fill="#7e7d7e"
                                    />
                                    <path
                                        d="M9.34,17.93l-.16,1.78c-.29-.09-.59-.04-.9-.07,0-.03-.01-.07-.01-.11.1-.06.06-.2.06-.3-.01-.45.11-.89.18-1.33.02.09-.05.19.05.33.11-.17.15-.3.33-.34.15-.04.29.05.45.06v-.02Z"
                                        fill="#8c8b8c"
                                    />
                                    <path
                                        d="M9.55,16.62l-.2,1.31c-.16,0-.3-.09-.45-.06-.18.04-.22.18-.33.34-.1-.13-.03-.24-.05-.33.09-.5.14-1.03.3-1.51.04.06.08.12.14.1.07-.02.15-.09.23-.1.19-.01.16.29.35.24l.01.01Z"
                                        fill="#878687"
                                    />
                                    <path
                                        d="M11.6,18.67l-.56,1.77-.39.11c-.04-.05-.02-.1-.02-.13.05-.14.05-.29.12-.42.06-.02.05-.07.06-.12.08-.42.24-.82.42-1.21.12-.01.25-.06.36,0h.01Z"
                                        fill="#8d8c8c"
                                    />
                                    <path
                                        d="M12.14,16.74c0,.29-.09.54-.18.81l-.36,1.12c-.12-.05-.24,0-.36,0,0-.02.02-.05.01-.07.08,0,.19,0,.23-.1.03-.08-.02-.17-.11-.19.1-.54.27-1.06.47-1.57.06.12.2.02.29,0h.01Z"
                                        fill="#888687"
                                    />
                                    <path
                                        d="M11.04,20.44c-.1.33-.11.72-.18,1.06-.2.02-.38.11-.57.19.03-.43.19-.85.35-1.25,0,.02-.01.07.02.13l.39-.11-.01-.02Z"
                                        fill="#959292"
                                    />
                                    <path
                                        d="M1.75,11.84c-.34-.04-.71.08-1.03-.06.34.04.71-.09,1.03.06Z"
                                        fill="#9d9998"
                                    />
                                    <path
                                        d="M20.25,11.84c-.32-.04-.67.08-.97-.06.32.04.67-.08.97.06Z"
                                        fill="#9d9998"
                                    />
                                    <path
                                        d="M11.25,18.61c-.03-.12.09-.21.12-.29.09.02.14.12.11.19-.04.09-.15.1-.23.1Z"
                                        fill="#8d8c8c"
                                    />
                                    <path
                                        d="M8.28,19.52c0-.1-.04-.24.06-.3,0,.1.04.24-.06.3Z"
                                        fill="#949190"
                                    />
                                    <path
                                        d="M11.96,16.14c0-.07-.01-.15.06-.18,0,.07.01.15-.06.18Z"
                                        fill="#888687"
                                    />
                                    <path
                                        d="M11.9,16.44c0-.07-.01-.15.06-.18,0,.07.01.15-.06.18Z"
                                        fill="#888687"
                                    />
                                    <path
                                        d="M12.33,16.2s-.05,0-.06-.04c0-.04.05-.06.06-.08v.12Z"
                                        fill="#888687"
                                    />
                                    <path
                                        d="M11.84,16.62s0-.11.06-.12c0,.05,0,.1-.06.12Z"
                                        fill="#888687"
                                    />
                                    <path
                                        d="M10.76,20.01s0-.1.06-.12c0,.05,0,.11-.06.12Z"
                                        fill="#959292"
                                    />
                                    <path
                                        d="M3.8,19.83c-.06-.02-.09-.07-.12-.12.05.02.11.06.12.12Z"
                                        fill="#959292"
                                    />
                                    <circle
                                        cx="7.01"
                                        cy="21.88"
                                        r=".07"
                                        fill="#959292"
                                    />
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>

                <!-- Dental Corp -->
                <div
                    v-else-if="companyName === 'Dental Corp'"
                    class="client-logo"
                >
                    <svg
                        width="25"
                        height="26"
                        viewBox="0 0 25 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M24.9901 12.6838C24.9813 12.706 24.9703 12.7237 24.9572 12.737C24.9396 12.7504 24.922 12.7614 24.9044 12.7703C24.8868 12.7792 24.8671 12.7836 24.8451 12.7836H23.441C13.5926 12.7836 12.6566 13.7286 12.6566 23.6707V25.0881C12.6566 25.1103 12.6522 25.1303 12.6434 25.148C12.6346 25.1702 12.6236 25.188 12.6104 25.2013C12.5972 25.2146 12.5797 25.2257 12.5577 25.2345C12.5401 25.2434 12.5203 25.2478 12.4984 25.2478C12.4808 25.2478 12.461 25.2434 12.439 25.2345C12.4214 25.2257 12.4061 25.2146 12.3929 25.2013C12.3753 25.188 12.3621 25.1702 12.3533 25.148C12.3489 25.1303 12.3467 25.1103 12.3467 25.0881V23.6707C12.3467 13.7286 11.4107 12.7836 1.56229 12.777H0.158207C0.136234 12.777 0.116458 12.7748 0.0988794 12.7703C0.0769062 12.7614 0.0593276 12.7481 0.0461437 12.7304C0.0329598 12.7171 0.0219732 12.7016 0.0131839 12.6838C0.00439464 12.6616 0 12.6417 0 12.6239C0 12.6017 0.00439464 12.5818 0.0131839 12.564C0.0219732 12.5418 0.0329598 12.5241 0.0461437 12.5108C0.0593276 12.4975 0.0769062 12.4864 0.0988794 12.4775C0.116458 12.4686 0.136234 12.4642 0.158207 12.4642H1.56229C11.4107 12.4642 12.3467 11.5192 12.3467 1.57716V0.159712C12.3467 0.13753 12.3511 0.117566 12.3599 0.0998201C12.3643 0.0776379 12.3753 0.0598921 12.3929 0.0465827C12.4061 0.0332734 12.4236 0.0221823 12.4456 0.0133094C12.4632 0.00443645 12.483 0 12.5049 0C12.5225 0 12.5423 0.00443645 12.5643 0.0133094C12.5819 0.0221823 12.5994 0.0332734 12.617 0.0465827C12.6302 0.0598921 12.6412 0.0776379 12.65 0.0998201C12.6544 0.117566 12.6566 0.13753 12.6566 0.159712V1.57716C12.6566 11.5192 13.5992 12.4642 23.441 12.4642H24.8451C24.8671 12.4642 24.889 12.4686 24.911 12.4775C24.9286 12.4864 24.944 12.4975 24.9572 12.5108C24.9747 12.5241 24.9857 12.5418 24.9901 12.564C24.9989 12.5818 25.0033 12.6017 25.0033 12.6239C25.0033 12.6461 24.9989 12.6661 24.9901 12.6838Z"
                            fill="#99CCFF"
                        />
                    </svg>
                </div>
                <h1
                    v-if="!isCompact"
                    class="client-name alpha-access text-start"
                    :class="{ loading: isLoading }"
                >
                    {{ companyName || 'Loading...' }}
                </h1>
            </div>

            <!-- Non-Alpha Access: Show name only (original behavior) -->
            <h1
                v-else-if="!isCompact"
                class="client-name text-start"
                :class="{ loading: isLoading }"
            >
                {{ companyName || 'Loading...' }}
            </h1>

            <!-- Sidebar Toggle -->
            <button
                v-if="!this.$isMobile"
                class="collapse-button"
                type="button"
                :aria-label="toggleButtonLabel"
                @click="toggleSidebar"
            >
                <i :class="['collapse-icon fi', collapseIconClass]"></i>
            </button>
        </div>

        <Field
            v-if="!isCompact && showRegionSelectField"
            type="select"
            label="Region"
            v-model="selectedRegionValue"
            :plain-text-mode="true"
            :params="{
                options: regionOptions,
                placeholder: 'All Regions',
            }"
        />

        <SiteDropdownField
            v-if="!isCompact && showGlobalSiteSelectField"
            type="select"
            :label="showRegionSelectField ? 'Site' : ''"
            v-model="selectedSite"
            placeholder="All Sites"
            :plain-text-mode="true"
        />
    </header>
</template>

<script>
import SiteDropdownField from '@/components/fields/SiteDropdownField.vue';
import Field from '@/components/Field.vue';
import {
    buildRegionProvinceOptions,
    decodeGlobalRegionSelection,
    encodeGlobalRegionSelection,
    loadRegions,
    REGION_UPDATED_EVENT,
} from '@/components/Region/region';
const LOGOS = {
    COMPACT: require('@/assets/images/logos/logomark.svg'),
    FULL: require('@/assets/images/logos/ipac-dashboard.svg'),
    BETA: require('@/assets/images/logos/ipac-dashboard-beta.svg'),
    VIEW_ONLY: require('@/assets/images/logos/ipac-dashboard-view-only.svg'),
};

export default {
    name: 'SideBarHeader',
    components: {
        SiteDropdownField,
        Field,
    },
    props: {
        isCompact: {
            type: Boolean,
            required: true,
            default: false,
        },
    },

    emits: ['link-clicked', 'toggle-sidebar'],

    data() {
        return {
            companyName: '',
            isLoading: true,
            hasLogoError: false,
            regionChangeToken: 0,
        };
    },

    computed: {
        /**
         * Determines which logo to display based on sidebar state
         */
        currentLogo() {
            return this.isCompact
                ? LOGOS.COMPACT
                : this.$userStore.isViewOnly
                ? LOGOS.VIEW_ONLY
                : LOGOS.FULL;
        },

        /**
         * Sets appropriate alt text for accessibility
         */
        logoAltText() {
            return this.isCompact ? 'IPAC Logo' : 'IPAC Dashboard Logo';
        },

        /**
         * Determines logo CSS class based on sidebar state
         */
        logoClass() {
            return this.isCompact ? 'dashboard-logo-compact' : 'dashboard-logo';
        },

        /**
         * Sets appropriate icon class for sidebar toggle
         */
        collapseIconClass() {
            return this.isCompact ? 'fi-sidebar-expand' : 'fi-sidebar-collapse';
        },

        /**
         * Returns appropriate button label for accessibility
         */
        toggleButtonLabel() {
            return this.isCompact ? 'Expand sidebar' : 'Collapse sidebar';
        },

        isBetaEnvironment() {
            return this.$env.environment === 'beta';
        },

        selectedSite: {
            get() {
                return this.$siteStore.globalSiteId;
            },
            set(value) {
                // ignore if unchanged
                if (value === this.$siteStore.globalSiteId) return;

                this.$siteStore.setGlobalSiteId(value);

                if (value != null && value !== '') {
                    this.$siteStore.setGlobalRegion(null);
                }

                // refresh dependent data
                this.$employeesStore.clear();
                this.$employeesStore.fetchEmployees();
            },
        },

        selectedRegionValue: {
            get() {
                return encodeGlobalRegionSelection(
                    this.$siteStore.globalRegion
                );
            },
            set(value) {
                const currentValue = encodeGlobalRegionSelection(
                    this.$siteStore.globalRegion
                );
                if (value === currentValue) return;

                const selection = decodeGlobalRegionSelection(
                    value,
                    this.customRegions,
                    this.provinceOptions
                );
                this.$siteStore.setGlobalRegion(selection);
            },
        },

        provinceOptions() {
            return this.$siteStore?.getProvinceOptions || [];
        },

        customRegions() {
            const companyId = this.$userStore?.company?.id;
            const sites = this.$siteStore?.sites || [];
            this.regionChangeToken; // depend on token to force recompute when region is updated
            return loadRegions(companyId, sites);
        },

        regionOptions() {
            return buildRegionProvinceOptions(
                this.customRegions,
                this.provinceOptions
            );
        },

        // Should show the global site select field
        showGlobalSiteSelectField() {
            // Hide in single-site-user view
            if (this.$siteStore.isSingleSiteUserView) return false;
            // Hide in admin routes
            if (this.isAdminRoute) return false;
            return true;
        },

        showRegionSelectField() {
            if (
                this.showGlobalSiteSelectField &&
                this.$userStore.hasAlphaAccess &&
                this.$route.name === 'Home' &&
                !this.$siteStore.globalSiteId
            ) {
                return true;
            }
            return false;
        },

        isAdminRoute() {
            return this.$route?.matched?.some((r) =>
                r.path.startsWith('/admin')
            );
        },
    },
    methods: {
        /**
         * Emits toggle event to parent
         */
        toggleSidebar() {
            this.$emit('toggle-sidebar');
        },

        /**
         * Handles logo loading errors
         */
        handleLogoError() {
            this.hasLogoError = true;
            console.error('Failed to load company logo');
        },

        /**
         * Sets company name from store data
         */
        setCompanyName() {
            if (this.$userStore.company && 'name' in this.$userStore.company) {
                this.companyName = this.$userStore.company.name;
            }
            this.isLoading = false;
        },

        /**
         * Fetches company name using store sync pattern
         */
        fetchCompanyName() {
            if (this.$userStore.user) {
                this.setCompanyName();
            } else {
                this.$userStore.sync(() => this.setCompanyName());
            }
        },

        handleRegionUpdate(event) {
            // Force recomputation of region-related computed properties by changing a dummy token
            this.regionChangeToken += 1;
        },
    },

    mounted() {
        this.fetchCompanyName();
        window.addEventListener(REGION_UPDATED_EVENT, this.handleRegionUpdate);
    },

    beforeUnmount() {
        window.removeEventListener(
            REGION_UPDATED_EVENT,
            this.handleRegionUpdate
        );
    },
};
</script>

<style scoped>
.client-info {
    gap: var(--space-2);
    flex: 1;
    min-width: 0;
    align-items: center;
}

.client-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 25px;
    height: 26px;
}

.client-logo svg {
    width: 25px;
    height: 26px;
    display: block;
}

.client-name {
    margin: 0;
    padding: 0;
    line-height: 17px;
    font-size: 14px;
    height: 17px;
    color: var(--primary-300);
    overflow: hidden;
    text-overflow: ellipsis;
    transition: all 0.3s ease-in-out;
    text-transform: capitalize;
}

.collapse-button {
    all: unset;
    cursor: pointer;
}

.separator-line {
    border-bottom: 1px solid var(--neutral-600);
}

.dashboard-logo {
    width: 142px;
    height: 55px;
    transition: all 0.3s ease-in-out;
}

.dashboard-logo-compact {
    width: 55px;
    height: 55px;
    transition: all 0.3s ease-in-out;
}

.collapse-icon {
    font-size: 20px;
    color: var(--primary-300);
}

.logo-link {
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    height: fit-content;
    padding: 0;
}

/*close btn*/
.btn {
    max-inline-size: 2.5rem;
    max-block-size: 2.5rem;
}

:deep(.dashboard-select-dropdown .form-control) {
    height: 34px;
    min-height: 34px;
    padding: 4px var(--space-3);
    line-height: normal;
}

/* Override badge height in sidebar context */
:deep(.dashboard-select-dropdown .selected-badge:not(.plain-text)) {
    height: auto;
    padding: 2px 8px;
}

:deep(.dashboard-select-dropdown .selected-badge:not(.plain-text) .badge-text) {
    line-height: 16px;
}

@media only screen and (max-width: 767.98px) {
    .dashboard-logo {
        width: 120px;
        height: 46px;
    }
}
</style>
